import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import {
  CustomerSupplierLedgerDetailFun,
  CustomerSupplierProAcDetail,
  CustomerSupplierProLedgerDetail,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Ledger({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { CustomerSupplierLedgerDetaildata } = useSelector(
    (state) => state.CustomerSlice,
  );
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    if (accountName.length === 0) return;
    dispatch(CustomerSupplierLedgerDetailFun());
    dispatch(
      CustomerSupplierProLedgerDetail({
        Firm,
        Year: YearId,
        AcIDs: accountName.join(","),
        selectedIds: accountGroup.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
    dispatch(
      CustomerSupplierProAcDetail({
        AcIDs: accountName,
      }),
    );
  }, [dispatch, Firm, YearId, accountName, accountGroup]);

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return ""; // Invalid date guard

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const getRows = CustomerSupplierLedgerDetaildata?.Data?.map(
    (label, index) => ({
      // srNumber: index + 1,
      VouDate: formatDateToDDMMYYYY(label.VouDate),
      VouNo: label.VouNo,
      TransactionName: label.TransactionName,
      ChqNo: label.ChqNo,
      CrAmt: label.CrAmt,
      DrAmt: label.DrAmt,
      BalAmt: label.BalAmt,
      AgAcName: label.AgAcName,
    }),
  );

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Vou Date", key: "VouDate", align: "center" },
    {
      label: "Transaction Name",
      key: "TransactionName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Vou No", key: "VouNo", align: "center" },
    { label: "Chq No", key: "ChqNo", align: "center" },
    { label: "Dr Amt", key: "DrAmt", align: "right", format: "true" },
    { label: "Cr Amt", key: "CrAmt", align: "right", format: "true" },
    { label: "Balance Amt", key: "BalAmt", format: "true", align: "right" },
    { label: "Ag Account Name", key: "AgAcName", align: "left" },
  ];

  const totals = CustomerSupplierLedgerDetaildata?.Summary?.reduce(
    (acc, item) => ({
      DrAmt: acc.DrAmt + (Number(item.DrAmt) || 0),
      CrAmt: acc.CrAmt + (Number(item.CrAmt) || 0),
    }),

    { DrAmt: 0, CrAmt: 0 },
  ) || { DrAmt: 0, CrAmt: 0 };

  if (accountName?.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          fontSize: "20px",
          color: isdark === "light" ? isdark?.Colour12 : iscolourDark?.Colour10,
        }}
      >
        Please Select Accounts Name
      </div>
    );
  }
  if (
    CustomerSupplierLedgerDetaildata === "no" ||
    CustomerSupplierLedgerDetaildata === null
  ) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            LEDGER
          </h2>
        </div>
        <FASTable
          data={getRows}
          columns={getColumns}
          externalTotals={{
            DrAmt: totals.DrAmt,
            CrAmt: totals.CrAmt,
          }}
        />
      </div>
    </div>
  );
}
